import * as Sentry from '@sentry/browser';
import { redactPiiDeep } from '@jas/shared';

let initialised = false;

/** Inert when NEXT_PUBLIC_SENTRY_DSN_WEB is unset. Idempotent. */
export function initSentry(): boolean {
  if (initialised) return true;
  const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN_WEB;
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV ?? 'development',
    release: process.env.NEXT_PUBLIC_RELEASE_SHA ?? undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    beforeSend(event) {
      return redactPiiDeep(event);
    },
    beforeBreadcrumb(crumb) {
      return redactPiiDeep(crumb);
    },
  });
  initialised = true;
  return true;
}
